import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog'
import { DialogDescription } from '@radix-ui/react-dialog'
import { type FC, useCallback, useState } from 'react'
import { MdMenu } from 'react-icons/md'
import { Button } from '../ui/button'
import { NavbarContent } from './navbar-content'

export const MobileNavbar: FC = () => {
    const [isOpen, setIsOpen] = useState(false)

    const onNavLinkClick = useCallback(() => {
        setIsOpen(false)
    }, [])

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                <Button variant="secondary" size="icon">
                    <MdMenu />
                </Button>
            </DialogTrigger>
            <DialogContent
                className="h-full w-full !max-w-full flex flex-col p-4"
                closeButtonClassName="!top-[2.25rem] !right-[2rem] absolute"
                innerContentClassName="p-0"
            >
                <DialogHeader className="hidden">
                    <DialogTitle className="hidden">XSY</DialogTitle>
                    <DialogDescription>XSY</DialogDescription>
                </DialogHeader>
                <NavbarContent onNavLinkClick={onNavLinkClick} className="border-none" />
            </DialogContent>
        </Dialog>
    )
}
